import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import NewUserComponent from "../component/new-user-component"
import UserPage from "../page/user-page"
export const UserRoute: RouteObject = {
  path: "/user",
  element: (
    <AuthGuard role={["super_admin"]} permission={["manage-users", "view-users"]}>
      <UserPage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewUserComponent editMode="detail" />,
    },
    { path: ":id", element: <NewUserComponent editMode="new" /> },
  ],
}
